<script setup lang="ts">
import { computed, ref } from "vue";
import FilePond from "../files/FilePond.vue";
import { useTenantStore } from "@/store";
import BaseButton from "../ui/buttons/BaseButton.vue";
// import Uploader from "../files/Uploader.vue";

const tenant = computed(() => useTenantStore().tenant)

interface ColorConfig {
  background: string;
  text: string;
  button: string;
  buttonText: string;
}

const colors = ref<ColorConfig>({
  background: "#3B67A5",
  text: "#FFFFFF",
  button: "#D92511",
  buttonText: "#F0F0F0"
});

const colorPalette = ["#000000", "#FFFFFF", "#3B67A5", "#00A896", "#E63946", "#F1FAEE", "#A8DADC", "#457B9D"];

const selectedColorType = ref<keyof ColorConfig | null>(null);

function handleColorChange(colorType: keyof ColorConfig, color: string) {
  if (selectedColorType.value === colorType) {
    selectedColorType.value = null;
  } else {
    selectedColorType.value = colorType;
    colors.value[colorType] = color;
  }
}


</script>

<template>
  <div class="w-full px-20 py-12 bg-white border shadow-lg rounded-xl">
    <div>
      <h1 class="mb-8 text-3xl font-semibold leading-9 text-gray-900">Branding</h1>

      <form class="mt-10">
        <div>
          <label for="logo-upload" class="block text-lg font-medium leading-7 text-gray-800">
            Logo de l'Agence*
          </label>
          <p class="mt-2 text-xs italic text-gray-500">Ce logo doit être au minimum 200x200px, taille maximale 5Mo.</p>
          <div class="mt-10">
            <div class="my-10" v-if="tenant.tenantBranding?.logoUrl">
              <img :src="tenant.tenantBranding?.logoUrl" class="max-w-96" />
            </div>
            <div class="cursor-pointer">
              <FilePond />
            </div>
          </div>
        </div>

        <div class="w-full my-16 border-t border-gray-300" />

        <div>
          <label for="logo-upload" class="block text-lg font-medium leading-7 text-gray-800">
            Icône <span class="ml-1 text-xs text-gray-500">(optionnel)</span>
          </label>
          <p class="mt-2 text-xs italic text-gray-500">La favicon doit être au minimum 32x32, taille maximale 500Ko.</p>
          <div class="mt-10">
            <div class="my-10" v-if="tenant.tenantBranding?.iconUrl">
              <img :src="tenant.tenantBranding?.iconUrl" class="rounded-md max-w-96" />
            </div>
            <div class="cursor-pointer">
              <FilePond />
            </div>
          </div>
        </div>

        <div class="mt-14">
          <BaseButton text="Valider" size="lg" type="submit" />
        </div>

        <!-- <div class="grid grid-cols-2 gap-4 mt-8">
          <div>
            <p>Arrière-Plan</p>
            <button
              class="flex items-center justify-center w-full col-span-1 border border-gray-300 rounded-lg aspect-w-1 aspect-h-1"
              :style="{ backgroundColor: colors.button, color: colors.buttonText }"
              @click="handleColorChange('button', '#FFFFFF')"
            >
              #{colors.buttonText}
            </button>
          </div>
        </div> -->
      </form>
    </div>
  </div>
</template>

<style scoped>
button {
  transition: background-color 0.3s, color 0.3s;
}
</style>
